import { DICTIONARY } from '@/constants/dictionary'
import { PFH_TITLE } from '@/constants/pfh'
import { PWC_TITLE } from '@/constants/pwc'
import type { Dictionary, Terminology } from '@/types/Dictionary'

export const prepareDictionary = (
  terminology?: Terminology | null,
  customNames: Partial<Dictionary> = {
    corporate: DICTIONARY.standard.corporate,
  }
) => {
  let dictionary: Dictionary = DICTIONARY.standard

  dictionary = {
    ...DICTIONARY.standard,
    ...(terminology ? DICTIONARY[terminology] : {}),
    ...customNames,
  }

  return dictionary
}

export const getTerminology = (rmcTitle = ''): Terminology | null => {
  const isPwc = rmcTitle.toLowerCase().includes(PWC_TITLE.toLowerCase())
  const isPfh = rmcTitle.toLowerCase().includes(PFH_TITLE.toLowerCase())

  if (isPwc) {
    return 'pwc'
  }

  if (isPfh) {
    return 'pfh'
  }

  return null
}

export const smartPluralize = (word: string, isPlural: boolean) => {
  if (!isPlural) return word

  if (word.endsWith('is')) {
    return `${word.slice(0, -2)}es`
  }

  if (/(s|x|z|ch|sh)$/i.test(word)) {
    return `${word}es`
  }

  if (/[bcdfghjklmnpqrstvwxz]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`
  }

  return `${word}s`
}
